import React from 'react';
import cn from 'classnames';

import Correct from 'shared/ui/icons/General/Correct';
import {isTranslate} from 'shared/lib/lang';

import styles from './NotifyChannels.module.scss';

const NotifyChannelStatusIcon: React.FC<{active: boolean}> = ({active}) => (
    <Correct
        className={cn(
            styles.statusIcon,
            active && (isTranslate() ? styles.statusIconActiveEn : styles.statusIconActive),
        )}
    />
);

export default NotifyChannelStatusIcon;
